import React from 'react';

import './Footer.scss';

function Footer() {

  return (
    <footer>
      <div className='container'>
        <a href='https://www.procempa.com.br' target='_blank' rel='noreferrer'>
          <img
            src='https://www.procempa.com.br/img/desenvolvimento_procempa.svg'
            alt='procempa'
            title='procempa'
          />
        </a>
      </div>
    </footer>
  );
}

export default Footer;
